import { useState, useEffect, useCallback, useContext, Suspense } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { Grid } from "@material-ui/core";
import { AnnouncementGroupInformation, AnnouncementTreeView } from "../../..";
import {
	AnnouncementGroupAndLocations,
	AssignedGroup,
	AssignedLocation,
	AssignmentStatus,
	GroupsAndLocations,
	LocationSchema
} from "../../../../../@types/group.types";
import { GroupContext, UIContext } from "../../../../../contexts";
import { useQuery } from "../../../../../hooks";
import { api } from "../../../../../utils/api";

import SelectAllIcon from "@material-ui/icons/SelectAll";

import "./assignGroups.css";
import { trackPromise } from "react-promise-tracker";

const AssignGroups = () => {
	const [groups, setGroups] = useState<GroupsAndLocations[]>([]);
	const [isValidAnnouncement, setIsValidAnnouncement] = useState(false);
	const [assignmentStatus, setAssignmentStatus] = useState<AssignmentStatus>();
	const [announcementId, setAnnouncementId] = useState("");
	const { setDashboardHeader } = useContext(UIContext);
	const { groupInformation, locationInformation, setGroupInformation, setLocationInformation } =
		useContext(GroupContext);
	const query = useQuery();

	const handleSelectProfile = (profile: GroupsAndLocations, type: "group" | "location") => {
		if (type === "group") {
			setGroupInformation(Object.assign({}, profile));
			setLocationInformation(null);
		} else if (type === "location") {
			setLocationInformation(Object.assign({}, profile));
			setGroupInformation(null);
		}
	};

	const getGroups = useCallback(async (id: string) => {
		const params = {
			announcement_id: id
		};
		const result = (await trackPromise(api.announcements.getGroups(params))) as {
			AnnouncementAndGroupLocations: AnnouncementGroupAndLocations;
		};
		if (result) {
			setGroups(Object.assign([], result.AnnouncementAndGroupLocations));
		}
	}, []);

	const handleAssignLocation = useCallback(
		async (location: LocationSchema, assigned: boolean) => {
			const { _id, group_number, location_name, location_number } = location;
			const payload = {
				announcement_id: announcementId,
				location_name,
				group_number,
				location_id_arrays: [location_number]
			};
			const result = (await trackPromise(api.announcements.assignLocations(payload))) as {
				AnnouncementAndGroupLocations: AnnouncementGroupAndLocations;
			};
		},
		[announcementId]
	);

	const handleSaveAllLocations = useCallback(
		async (checkedLocationsIds: any) => {
			const payload = {
				announcement_id: announcementId,

				location_id_arrays: checkedLocationsIds
				// assigned,
				// access: "read"
			};

			const result = (await trackPromise(api.announcements.assignLocations(payload))) as {
				AnnouncementAndGroupLocations: AnnouncementGroupAndLocations;
			};
			if (result) {
				setGroups(Object.assign([], result.AnnouncementAndGroupLocations));
				// console.log("assigning", result, groups);
				// setAssignmentStatus(Object.assign({}, result.assignmentStatus));
			}
		},
		[announcementId, assignmentStatus?.all_groups, assignmentStatus?.all_locations, groups]
	);

	const getAnnouncementValidity = useCallback(
		async (id: string | null) => {
			if (id === null) {
				return;
			}
			setIsValidAnnouncement(true);
			getGroups(id);
			// const _announcement = await api.announcements.getAnnouncementById(id);
			// if (_announcement && id) {
			// 	setIsValidAnnouncement(true);
			// 	getGroups(id);
			// }
		},
		[getGroups]
	);

	useEffect(() => {
		if (query && typeof query.get("id") === "string" && query.get("id") !== null) {
			getAnnouncementValidity(query.get("id"));
			setAnnouncementId(query.get("id") as string);
		}
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.limit_groups);
	}, [getAnnouncementValidity, getGroups, query, setDashboardHeader]);

	return (
		<div className="assign-groups">
			{isValidAnnouncement ? (
				<div className="assign-groups-container">
					<Grid container spacing={2} style={{ height: "100%" }}>
						<Grid item xl={4} lg={4} md={4} xs={12} sm={12}>
							<Suspense fallback={<div />}>
								{groups ? (
									<AnnouncementTreeView
										groups={groups}
										announcementId={announcementId}
										// assignmentStatus={assignmentStatus}
										// handleAssignGroup={handleAssignGroup}
										handleAssignLocation={handleAssignLocation}
										// handleSaveAllGroups={handleSaveAllGroups}
										handleSaveAllLocations={handleSaveAllLocations}
										handleSelectProfile={handleSelectProfile}
									/>
								) : null}
							</Suspense>
						</Grid>
						<Grid item xl={8} lg={8} md={8} xs={12} sm={12} className="group-info">
							<Suspense fallback={<div />}>
								{groupInformation || locationInformation ? (
									<AnnouncementGroupInformation />
								) : (
									<div className="no-result">
										<span>
											<SelectAllIcon />
										</span>
										Select a group/or location
									</div>
								)}
							</Suspense>
						</Grid>
					</Grid>
				</div>
			) : null}
		</div>
	);
};

export default AssignGroups;
